import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=808fd578&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./InviteUser.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('808fd578')) {
      api.createRecord('808fd578', component.options)
    } else {
      api.reload('808fd578', component.options)
    }
    module.hot.accept("./InviteUser.vue?vue&type=template&id=808fd578&", function () {
      api.rerender('808fd578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/ModalInviteEmployee/InviteUser.vue"
export default component.exports